export default __webpack_public_path__ + "static/media/DimensioningImg.556719f2.jpg";